/**
 * Constants for stowage-related query parameters and navigation
 */
export const STOWAGE_PARAMS = {
    STOWAGE_PLAN_GUID: 'stowagePlanGuid',
    PORT_CALL_GUID: 'portCallGuid',
    BERTH_CALL_GUID: 'berthCallGuid',
    CARGO_OPERATION_GUID: 'cargoOperationGuid',
} as const;

export const DEFAULT_STOWAGE_PARAMS = ['imoNumber'] as const;

export const STOWAGE_STORAGE_KEY = 'lastStowageParams';

export const STOWAGE_PAGE_PATH = '/stowage';

/**
 * Array of all stowage-specific parameter names
 */
export const ALL_STOWAGE_PARAMS = Object.values(STOWAGE_PARAMS);
